import type { Action } from 'redux';
import { type TakeableChannel } from 'redux-saga';
import {
  actionChannel, take,
} from 'redux-saga/effects';
import { logError } from '~/_shared/utils/logError';

export function* logErroneousActions() {
  const errorActionsChannel: TakeableChannel<Action> = yield actionChannel(
    (action: Action) => action.type.includes('ERROR')
  );

  while (true) {
    const action: Action = yield take(errorActionsChannel);

    logError('Error action detected:', action);
  }
}
